<nz-table
    #basicTable
    [nzData]="data"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
    [nzBordered]="false"
    [nzLoading]="loading"
>
    <thead class="table-header th-sticky sortable text-center">
        <tr *ngIf="basicTable?.data?.length > 0">
            <th [nzAlign]="'center'" [colspan]="group.columns.length" *ngFor="let group of columnGroups">
                {{ group.name | uppercase }}
            </th>
        </tr>
        <tr *ngIf="basicTable?.data?.length > 0">
            <th [nzAlign]="'center'" *ngFor="let column of columns">{{ column.label | titlecase }}</th>
        </tr>
    </thead>
    <tbody>
        <tr  *ngIf="basicTable?.data?.length > 0" class="custom-footer-row">
            <td [nzAlign]="'center'" class="custom-footer" *ngIf="!totals">Totals</td>
            <td [nzAlign]="'center'" class="custom-footer" *ngIf="totals">{{ getColumnTotal('sku_plan') }}</td>
            <td [nzAlign]="'center'" *ngFor="let col of columns | slice : 1" class="custom-footer">
                <ng-container [ngSwitch]="col.type">
                    <ng-container *ngSwitchCase="'decimal'">
                        {{ getColumnTotal(col.name) | thousandSeparator }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'percentage'">
                        {{ roundToTwoDecimals(getColumnTotal(col.name)) | shortNumber | percentValue }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'text'">
                        {{ getColumnTotal(col.name) }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
        <tr *ngFor="let data of basicTable.data; index as i" class="editable-row" (click)="startEdit(i)">
            <td [nzAlign]="'center'" [class]="skuCountClass()">
                <div *ngIf="!editable(i)" >
                    {{ data.sku_plan }}
                </div>
                <input
                    lynkdPatternAutoFocus
                    nz-input
                    type="number"
                    min="0"
                    step="1"
                    onkeypress="if(event.key==='.'){event.preventDefault();}"
                    *ngIf="editable(i)"
                    [(ngModel)]="data.sku_plan"
                    (keydown.enter)="stopEdit(i, data.sku_plan)"
                    (blur)="stopEdit(i, data.sku_plan)"
                />
            </td>
            <td [nzAlign]="'center'" *ngFor="let col of columns | slice : 1; index as i" class="readonly-column">
                <ng-container [ngSwitch]="col.type">
                    <ng-container *ngSwitchCase="'decimal'">
                        {{ data[col.name] ? (data[col.name] | thousandSeparator) : 0 }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'percentage'">
                        {{ data[col.name] ? (roundToTwoDecimals(data[col.name]) | percentValue) : 0 }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'text'">
                        {{ data[col.name] ? data[col.name] : 0 }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </tbody>
</nz-table>
